<template>
<div class="chapter">
<div class="inner_page">
<div>
<h1 class="sigil_not_in_toc" id="toc_marker-4"></h1>
<h2 id="toc_marker-5" title="Dedication"></h2>
<p class="body"></p>
<p class="center"><em>For my loving wife, Dana<br/>
    And for the children of the revolution</em></p>
<p class="body"></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?d960c1b2